const setItem = function setLocalStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

const getItem = function getLocalStorage(key) {
  return JSON.parse(localStorage.getItem(key))
}

export default { setItem, getItem }
